var map = {
	"./bialystok/podatek-od-nieruchomosci/section-2_pl.mdx": [
		97427,
		97427
	],
	"./bydgoszcz/podatek-od-nieruchomosci/section-2_pl.mdx": [
		13150,
		13150
	],
	"./czestochowa/podatek-od-nieruchomosci/section-2_pl.mdx": [
		56833,
		56833
	],
	"./garwolin/podatek-od-nieruchomosci/section-2_pl.mdx": [
		40804,
		40804
	],
	"./gdansk/podatek-od-nieruchomosci/section-2_pl.mdx": [
		18979,
		18979
	],
	"./gdynia/podatek-od-nieruchomosci/section-2_pl.mdx": [
		17795,
		17795
	],
	"./gliwice/podatek-od-nieruchomosci/section-2_pl.mdx": [
		74491,
		74491
	],
	"./gmina-swidnica/podatek-od-nieruchomosci/section-2_pl.mdx": [
		5448,
		5448
	],
	"./kielce/podatek-od-nieruchomosci/section-2_pl.mdx": [
		97898,
		97898
	],
	"./kolobrzeg/podatek-od-nieruchomosci/section-2_pl.mdx": [
		49564,
		49564
	],
	"./konskowola/podatek-od-nieruchomosci/section-2_pl.mdx": [
		42547,
		42547
	],
	"./koszalin/podatek-od-nieruchomosci/section-2_pl.mdx": [
		78130,
		78130
	],
	"./lask/podatek-od-nieruchomosci/section-2_pl.mdx": [
		68646,
		68646
	],
	"./lodz/podatek-od-nieruchomosci/section-2_pl.mdx": [
		63288,
		63288
	],
	"./lublin/podatek-od-nieruchomosci/section-2_pl.mdx": [
		60691,
		60691
	],
	"./miejsce-piastowe/podatek-od-nieruchomosci/section-2_pl.mdx": [
		412,
		412
	],
	"./mikolow/podatek-od-nieruchomosci/section-2_pl.mdx": [
		38851,
		38851
	],
	"./naklo/podatek-od-nieruchomosci/section-2_pl.mdx": [
		44740,
		44740
	],
	"./oborniki/podatek-od-nieruchomosci/section-2_pl.mdx": [
		45810,
		45810
	],
	"./olesnica/podatek-od-nieruchomosci/section-2_pl.mdx": [
		67003,
		67003
	],
	"./postomino/podatek-od-nieruchomosci/section-2_pl.mdx": [
		88447,
		88447
	],
	"./poznan/podatek-od-nieruchomosci/section-2_pl.mdx": [
		51399,
		51399
	],
	"./przechlewo/podatek-od-nieruchomosci/section-2_pl.mdx": [
		71858,
		71858
	],
	"./radom/podatek-od-nieruchomosci/section-2_pl.mdx": [
		79940,
		79940
	],
	"./raszkow/podatek-od-nieruchomosci/section-2_pl.mdx": [
		59432,
		59432
	],
	"./rawicz/podatek-od-nieruchomosci/section-2_pl.mdx": [
		11805,
		11805
	],
	"./ryman/podatek-od-nieruchomosci/section-2_pl.mdx": [
		50560,
		50560
	],
	"./sierakowice/podatek-od-nieruchomosci/section-2_pl.mdx": [
		13793,
		13793
	],
	"./slawno/podatek-od-nieruchomosci/section-2_pl.mdx": [
		60473,
		60473
	],
	"./slawoborze/podatek-od-nieruchomosci/section-2_pl.mdx": [
		56295,
		56295
	],
	"./stare-babice/podatek-od-nieruchomosci/section-2_pl.mdx": [
		17111,
		17111
	],
	"./szczecin/podatek-od-nieruchomosci/section-2_pl.mdx": [
		77640,
		77640
	],
	"./szemud/podatek-od-nieruchomosci/section-2_pl.mdx": [
		34159,
		34159
	],
	"./warszawa/podatek-od-nieruchomosci/section-2_pl.mdx": [
		61059,
		61059
	],
	"./wloszczowa/podatek-od-nieruchomosci/section-2_pl.mdx": [
		26430,
		26430
	],
	"./wroclaw/podatek-od-nieruchomosci/section-2_pl.mdx": [
		77854,
		77854
	],
	"./wyszkow/podatek-od-nieruchomosci/section-2_pl.mdx": [
		56037,
		56037
	],
	"./zukowo/podatek-od-nieruchomosci/section-2_pl.mdx": [
		90178,
		90178
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 84176;
module.exports = webpackAsyncContext;